export const IMPORT_DOCUMENT_JSON = 'IMPORT_DOCUMENT_JSON';
export const IMPORT_DOCUMENT_JSON_SUCCESS = 'IMPORT_DOCUMENT_JSON_SUCCESS';
export const IMPORT_DOCUMENT_JSON_FAILURE = 'IMPORT_DOCUMENT_JSON_FAILURE';

export const FETCH_DOCUMENT_QUEUE = 'FETCH_DOCUMENT_QUEUE';
export const FETCH_DOCUMENT_QUEUE_SUCCESS = 'FETCH_DOCUMENT_QUEUE_SUCCESS';
export const FETCH_DOCUMENT_QUEUE_FAILURE = 'FETCH_DOCUMENT_QUEUE_FAILURE';
